import { render } from "./ClientReporteComisiones.vue?vue&type=template&id=56d1cf0c&scoped=true"
import script from "./ClientReporteComisiones.vue?vue&type=script&lang=js"
export * from "./ClientReporteComisiones.vue?vue&type=script&lang=js"

import "./ClientReporteComisiones.vue?vue&type=style&index=0&id=56d1cf0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d1cf0c"]])

export default __exports__